<template>
    <div>
        <MobileHeader active="business"></MobileHeader>

        <el-row>
            <h1>业务聚焦</h1>
        </el-row>


        <div style="padding-top: 10px;">
            <div class="pic" v-for="o in 7" v-bind:key="o" @click="selected = o">
                <div>
                    <img v-show="selected !== o" :src="resourcePrefix + '/images/tubiao/' + o + '-1.png'" class="img" />
                    <img v-show="selected === o" :src="resourcePrefix + '/images/tubiao/' + o + '-2.png'" class="img" />
                </div>
                <div><span class="text-black ">{{businessArray[o - 1]}}</span></div>
            </div>
        </div>

            <div v-for="o in 7" v-bind:key="o" v-show="selected === o" style="margin-bottom: 60px;">
                <div>
                    <img :src="businessContentArray[o - 1].img" style="width: 100%;height: auto;" />
                </div>
                <div class="">
                    <div class="" style="margin:10px 20px 10px 20px">
                        <div>
                            <h2 class="">{{businessContentArray[o - 1].title}}</h2>
                        </div>
                    </div>
                </div>
                <div  style="margin: 0 20px 0 20px">
                    <div class="business-content">
                        {{businessContentArray[o - 1].content}}
                    </div>
                </div>
            </div>

       <MobileFooter></MobileFooter>
    </div>
</template>

<script>
    import MobileHeader from "../../components/MobileHeader";
    import {global} from "../../utils/global";
    import MobileFooter from "../../components/MobileFooter";

    export default {
        name: "MobileBusiness",
        components: {MobileFooter, MobileHeader},
        data () {
            return {
                resourcePrefix: global.RESOURCE_PREFIX,
                selected: 1,
                businessArray: [
                    '智慧应用',
                    '智能装备',
                    '工业互联网',
                    '数据管理',
                    '软件服务',
                    '系统集成',
                    '技术咨询'
                ],
                businessContentArray: [
                    {
                        title: '智慧应用',
                        img: require('../../assets/imgs/business/智慧应用.jpg'),
                        content: '以人工智能应用为主，以大数据智能化为引领的智能化技术与管理的应用，主要聚焦在智慧城市的整体规划与运营，面向智慧城市和智慧产业的实施与开发，具体包括公共服务、公共安全、城市治理、智慧产业等应用领域。'
                    },
                    {
                        title: '智能装备',
                        img: require('../../assets/imgs/business/智能装备.jpg'),
                        content: '通过智慧城市建设，深度挖掘智慧康养、智慧社区、智慧交通、智慧旅游等智慧场景的智能装备创新应用，联合高校科研院所、联盟组织等生态资源共创共享，为客户提供极致体验的智能产品，并实现产业化。'
                    },
                    {
                        title: '工业互联网',
                        img: require('../../assets/imgs/business/工业互联网.jpg'),
                        content: '通过工业级网络平台把设备、生产线、工厂、供应商、产品和客户紧密地连接和融合起来，高效共享工业经济中的各种要素资源，从而通过自动化、智能化的生产方式降低成本、增加效率，帮助制造业延长产业链，推动制造业转型发展。通过智能机器间的连接并最终将人机连接，结合软件和大数据分析，重构工业、激发生产力。'
                    },
                    {
                        title: '数据管理',
                        img: require('../../assets/imgs/business/数据管理.jpg'),
                        content: '围绕客户需求，提供相应的大数据应用服务、大数据探索服务、大数据运维服务、大数据汇聚服务，打造企业级数据治理体系，提供数据存储、加工处理以及挖掘分析，既可以满足企业全数据生命周期的服务需求，也可以满足有侧重的个性化的数据服务需求，帮助客户管理数据资产并创造商业价值。'
                    },
                    {
                        title: '软件服务',
                        img: require('../../assets/imgs/business/软件服务.jpg'),
                        content: '依托成熟的系统架构以及优秀的管理团队，为企业和机构提供高质量的软件产品和系统服务，包括应用系统定制开发、微信应用系统定制开发、移动门户设计开发、Android系统软件开发、技术培训服务、企业管理咨询服务、后期运维服务等。'
                    },
                    {
                        title: '系统集成',
                        img: require('../../assets/imgs/business/系统集成.jpg'),
                        content: '面向各级政府，事业单位及国内外各类企业、开展以系统集成业务为核心的网络工程设计施工、数据中心建设及其运维服务。提供低成本、高效率、性能匀称、可扩充性和可维护的集成系统服务。'
                    },
                    {
                        title: '技术咨询',
                        img: require('../../assets/imgs/business/技术咨询.jpg'),
                        content: '为用户提供智慧城市建设总体解决方案，包括城市大脑、智慧社区、智慧交通、智慧康养、智慧城建、智慧旅游、智能制造、智慧就业、系统集成、工业云等领域相关技术及方案咨询。'
                    }
                ]
            }
        },
        mounted () {
            if (this.$route.query && this.$route.query.businessName) {
                const numberMap = {
                    application: 1,
                    equipment: 2,
                    industry: 4,
                    manufacture: 3,
                    data: 5,
                    software: 6,
                    integrated: 7,
                    advisory: 8

                };
                this.selected = numberMap[this.$route.query.businessName];
            }
        }
    }
</script>

<style scoped>
    .pic {
        position: relative;
        float: left;
        height: auto;
        width: calc(25% - 5px);
        margin-right: 5px;
        margin-bottom: 5px;
        padding-bottom: 10px;
        padding-top: 10px;
        text-align: center;
        /*font-size: 30px;*/
        background-color: #f0f0f0;
    }

    .img {
        width: 60%;
        height: auto;
    }

    .text-xxl {
        font-size: 50px;
        text-align: center;
    }

    .title {
        font-size: 40px;

    }

    .content {
        font-size: 30px;
    }

    .hiden {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        color: grey;
    }
    .san1{
        width: 150px;
        height: 150px;
        position: absolute;
        top: 375px !important;
        left: 400px !important;
        z-index: 8888;
    }

    .business-content {
        color: grey;
        text-align: left;
        font-size: 16px;
        line-height: 24px;
        text-indent: 2em;

        /*text-align: justify;*/
        /*text-justify: inter-ideograph;*/
    }

    .main-color {
        color: #ff4e00;
    }
</style>
